var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("el-card", { staticStyle: { "margin-bottom": "10px" } }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            staticStyle: {
              "padding-bottom": "10px",
              "font-size": "20px",
              "padding-top": "10px",
            },
          },
          [
            _c("div", [
              _c("span", [
                _vm._v(_vm._s(_vm.productStatisticsData.merchantName)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { "margin-top": "20px", "margin-bottom": "-15px" },
              },
              [
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    attrs: { value: _vm.productStatisticsData.todayUpCount },
                  },
                  [
                    _c("el-button", { attrs: { size: "small" } }, [
                      _vm._v("今日上架产品"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    attrs: { value: _vm.productStatisticsData.todayDownCount },
                  },
                  [
                    _c("el-button", { attrs: { size: "small" } }, [
                      _vm._v("今日下架产品"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    attrs: {
                      value: _vm.productStatisticsData.todayChangeCount,
                    },
                  },
                  [
                    _c("el-button", { attrs: { size: "small" } }, [
                      _vm._v("今日变化产品"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              ref: "headerBox",
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-tabs",
                {
                  on: {
                    "tab-click": function ($event) {
                      _vm.getList(1), _vm.goodHeade()
                    },
                  },
                  model: {
                    value: _vm.tableFrom.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.tableFrom, "type", $$v)
                    },
                    expression: "tableFrom.type",
                  },
                },
                _vm._l(_vm.headeNum, function (item, index) {
                  return _c("el-tab-pane", {
                    key: index,
                    attrs: {
                      label: item.name + "(" + item.count + ")",
                      name: item.type.toString(),
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowSeach,
                      expression: "isShowSeach",
                    },
                  ],
                  staticClass: "container mt-1",
                },
                [
                  _c(
                    "el-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类：" } },
                        [
                          _c("el-cascader", {
                            ref: "cascader",
                            staticClass: "selWidth",
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              options: _vm.adminProductClassify,
                              props: _vm.categoryProps,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.getList(1)
                              },
                            },
                            model: {
                              value: _vm.tableFrom.categoryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.tableFrom, "categoryId", $$v)
                              },
                              expression: "tableFrom.categoryId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.tableFrom.type === "1"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "商品状态：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getList(1)
                                    },
                                  },
                                  model: {
                                    value: _vm.tableFrom.isShow,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.tableFrom, "isShow", $$v)
                                    },
                                    expression: "tableFrom.isShow",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品搜索：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入商品名称，关键字",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.keywords,
                                callback: function ($$v) {
                                  _vm.keywords = $$v
                                },
                                expression: "keywords",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getList(1)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              Number(_vm.tableFrom.type) === 1
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "0px" },
                      attrs: { size: "mini" },
                      on: { click: _vm.batchOff },
                    },
                    [_vm._v("批量强制下架")]
                  )
                : _vm._e(),
              _vm._v(" "),
              Number(_vm.tableFrom.type) === 2
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "0px" },
                      attrs: { size: "mini" },
                      on: { click: _vm.batchOn },
                    },
                    [_vm._v("批量强制上架")]
                  )
                : _vm._e(),
              _vm._v(" "),
              Number(_vm.tableFrom.type) === 2
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "0px" },
                      attrs: { size: "mini" },
                      on: { click: _vm.batchORemove },
                    },
                    [_vm._v("批量强制产品移除")]
                  )
                : _vm._e(),
              _vm._v(" "),
              Number(_vm.tableFrom.type) === 3
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "0px" },
                      attrs: { size: "mini" },
                      on: { click: _vm.batchProductImport },
                    },
                    [_vm._v("批量强制导入产品")]
                  )
                : _vm._e(),
              _vm._v(" "),
              Number(_vm.tableFrom.type) === 3
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "0px" },
                      attrs: {
                        icon: "el-icon-upload",
                        type: "info",
                        plain: "",
                        size: "mini",
                      },
                      on: { click: _vm.batchProduct },
                    },
                    [_vm._v("产品库全量导入")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": true,
                "header-cell-style": { fontWeight: "bold" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                key: "2",
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-row",
                          {
                            staticStyle: { "margin-top": "5px" },
                            attrs: { type: "flex", align: "middle" },
                          },
                          [
                            row.isShow
                              ? _c("el-col", { attrs: { span: 12 } }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "15px",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [_vm._v(" 商品名称： ")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(row.name) +
                                      "\n            "
                                  ),
                                ])
                              : _c("el-col", { attrs: { span: 12 } }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "15px",
                                        "font-weight": "bold",
                                        color: "red",
                                      },
                                    },
                                    [_vm._v(" 商品名称： ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(row.name))]
                                  ),
                                ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "15px",
                                    "font-weight": "bold",
                                  },
                                },
                                [_vm._v(" 供应链商户： ")]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(row.merchantName) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 5 } }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "15px",
                                    "font-weight": "bold",
                                    "padding-left": "15px",
                                  },
                                },
                                [_vm._v(" 导入日期：")]
                              ),
                              _vm._v(
                                "\n              " +
                                  _vm._s(row.createTime) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  "text-align": "right",
                                  "padding-right": "5px",
                                },
                                attrs: { span: 3 },
                              },
                              [
                                Number(_vm.tableFrom.type) < 2 &&
                                _vm.checkPermi(["platform:product:force:down"])
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOff(row.pid)
                                          },
                                        },
                                      },
                                      [_vm._v("强制下架")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                Number(_vm.tableFrom.type) === 2
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOn(row.pid)
                                          },
                                        },
                                      },
                                      [_vm._v("强制上架")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                Number(_vm.tableFrom.type) === 2
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove(row.pid)
                                          },
                                        },
                                      },
                                      [_vm._v("产品移除")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                Number(_vm.tableFrom.type) === 3
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handProductImport(row.id)
                                          },
                                        },
                                      },
                                      [_vm._v("上架")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              data: row.skuList,
                              border: "",
                              "show-header": true,
                            },
                          },
                          [
                            _vm.checkedCities.includes("商品图")
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "SKU图",
                                    "min-width": "80",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "demo-image__preview",
                                              },
                                              [
                                                _c("el-image", {
                                                  staticStyle: {
                                                    width: "36px",
                                                    height: "36px",
                                                  },
                                                  attrs: {
                                                    src: scope.row.image,
                                                    "preview-src-list": [
                                                      scope.row.image,
                                                    ],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "SKUID",
                                prop: "id",
                                "min-width": "90",
                                "show-overflow-tooltip": true,
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "SKU名称",
                                prop: "sku",
                                "min-width": "180",
                                "show-overflow-tooltip": true,
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "市场价",
                                prop: "otPrice",
                                "min-width": "100",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "成本价",
                                prop: "customerRtPrice",
                                "min-width": "100",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(
                                                  scope.row.customerRtPrice
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "利润率",
                                prop: "rateProfit",
                                "min-width": "100",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.rateProfit > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: { color: "green" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.rateProfit) +
                                                    "%"
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "crimson",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.rateProfit) +
                                                    "%"
                                                ),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _vm.checkedCities.includes("销量")
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "sales",
                                    label: "销量",
                                    "min-width": "100",
                                    align: "center",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkedCities.includes("库存")
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "stock",
                                    label: "库存",
                                    "min-width": "70",
                                    align: "center",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                "min-width": "180",
                                fixed: "right",
                                align: "center",
                                "render-header": _vm.renderHeader,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAudit(
                                                  scope.row.productId,
                                                  false
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("详情")]
                                        ),
                                        _vm._v(" "),
                                        _vm.tableFrom.type === "1"
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handlePreview(
                                                      scope.row.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("预览")]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.card_select_show,
              expression: "card_select_show",
            },
          ],
          staticClass: "card_abs",
        },
        [
          [
            _c(
              "div",
              { staticClass: "cell_ht" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.checkSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleCheckedCitiesChange },
                model: {
                  value: _vm.checkedCities,
                  callback: function ($$v) {
                    _vm.checkedCities = $$v
                  },
                  expression: "checkedCities",
                },
              },
              _vm._l(_vm.columnData, function (item) {
                return _c(
                  "el-checkbox",
                  {
                    key: item,
                    staticClass: "check_cell",
                    attrs: { label: item },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("info-from", {
        ref: "infoFrom",
        attrs: {
          componentKey: _vm.componentKey,
          "is-atud": _vm.isAtud,
          "is-show": _vm.isShow,
          productId: _vm.productId,
        },
        on: { subSuccess: _vm.subSuccess },
      }),
      _vm._v(" "),
      _vm.previewVisible
        ? _c(
            "div",
            [
              _c("div", {
                staticClass: "bg",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.previewVisible = false
                  },
                },
              }),
              _vm._v(" "),
              _vm.previewVisible
                ? _c("preview-box", {
                    ref: "previewBox",
                    attrs: { frontDomainUrl: _vm.frontDomainUrl },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }